export const checkAllAttrFilled = (Obj) => {
  for (var key in Obj) {
    if (Obj[key] || key === 'def_group_id') {
    } else return false;
  }
  return true;
};
